import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Container, Box, Typography, Chip, Paper } from '@mui/material';
import api, { getMediaUrl } from '../services/api';

const BlogPost = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await api.get(`/blogs/${slug}`);
        setBlog(response.data);
      } catch (error) {
        console.error('Error fetching blog:', error);
      } finally {
        setLoading(false);
      }
    };
    fetchBlog();
  }, [slug]);

  if (loading) {
    return (
      <Container sx={{ py: 8 }}>
        <Typography>Loading...</Typography>
      </Container>
    );
  }

  if (!blog) {
    return (
      <Container sx={{ py: 8 }}>
        <Typography>Blog post not found</Typography>
      </Container>
    );
  }

  return (
    <Container sx={{ py: 8, maxWidth: 'md' }}>
      <Box sx={{ mb: 4 }}>
        <Chip label={blog.category} sx={{ mb: 2 }} />
        <Typography variant="h3" gutterBottom>
          {blog.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {new Date(blog.createdAt).toLocaleDateString()} • {blog.views} views
          {blog.author && ` • By ${blog.author.name}`}
        </Typography>
        {blog.featuredImage && (
          <Box
            component="img"
            src={getMediaUrl(blog.featuredImage)}
            alt={blog.title}
            sx={{ width: '100%', borderRadius: 2, mb: 4 }}
          />
        )}
      </Box>

      <Paper sx={{ p: 4 }}>
        <Box
          dangerouslySetInnerHTML={{ __html: blog.content }}
          sx={{
            '& p': { mb: 2 },
            '& h1, & h2, & h3': { mt: 3, mb: 2 },
            '& ul, & ol': { pl: 4, mb: 2 },
          }}
        />
      </Paper>

      {blog.tags && blog.tags.length > 0 && (
        <Box sx={{ mt: 4, display: 'flex', flexWrap: 'wrap', gap: 1 }}>
          {blog.tags.map((tag, index) => (
            <Chip key={index} label={tag} size="small" />
          ))}
        </Box>
      )}
    </Container>
  );
};

export default BlogPost;

